export default function Footer() {
  return (
    <>
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/923711432451?text=I+have+a+question+related+to+your+website+https://flightfare.pk"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 cursor-pointer"
        aria-label="Chat on WhatsApp"
      >
        {/* Ping ring */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-60" />
        {/* Button */}
        <span className="relative w-14 h-14 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 transition-colors">
          <i className="ri-whatsapp-line text-white text-3xl"></i>
        </span>
      </a>

      {/* Footer */}
      <footer className="bg-gray-100 pt-12 pb-6 mt-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pb-10 border-b border-gray-200">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <a href="/" className="inline-block mb-3">
                <img
                  src="https://storage.readdy-site.link/project_files/6f8e2f56-80e7-4d90-9ea4-7823017b65ac/8001b0b9-8322-4e8e-a8ae-9e1b8da726a7_Untitled-design-13-2.png?v=4559551c5eed3b8ee3339af394cf2f6c"
                  alt="flightfare.pk"
                  className="h-14 w-auto object-contain"
                />
              </a>
              <p className="text-sm text-gray-500 leading-relaxed">
                flightfare.pk connects travellers across Pakistan with the best flight deals,
                curated tour packages, and complete travel support — all under one roof. We make
                every trip easier, from the first search to the final boarding gate.
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a
                  href="https://www.facebook.com/share/1E1YkhMex1/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="http://instagram.com/flightfare.pk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-pink-600 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-fill text-xl"></i>
                </a>
              </div>
            </div>

            {/* Trending Visas */}
            <div>
              <p className="text-sm font-bold text-gray-900 mb-4">Trending Visas</p>
              <div className="flex flex-col gap-2">
                {["Malaysia", "Singapore", "Thailand"].map(v => (
                  <a
                    key={v}
                    href={`/visa/${v.toLowerCase()}`}
                    className="text-sm text-gray-500 hover:text-gray-800 transition-colors cursor-pointer"
                  >
                    {v}
                  </a>
                ))}
              </div>
            </div>

            {/* Bookings */}
            <div>
              <p className="text-sm font-bold text-gray-900 mb-4">Bookings</p>
              <div className="flex flex-col gap-2">
                {[
                  { label: "Flights", href: "/" },
                  { label: "Travel Insurance", href: "/insurance" },
                  { label: "International Tours", href: "/tours" },
                  { label: "Our Services", href: "/services" },
                ].map(({ label, href }) => (
                  <a
                    key={label}
                    href={href}
                    className="text-sm text-gray-500 hover:text-gray-800 transition-colors cursor-pointer"
                  >
                    {label}
                  </a>
                ))}
              </div>
            </div>

            {/* Right columns group */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <p className="text-sm font-bold text-gray-900 mb-4">Umrah</p>
                <div className="flex flex-col gap-2">
                  {[
                    { label: "Umrah Packages", href: "/umrah" },
                    { label: "Make My Own Package", href: "/umrah-package" },
                  ].map(({ label, href }) => (
                    <a
                      key={label}
                      href={href}
                      className="text-sm text-gray-500 hover:text-gray-800 transition-colors cursor-pointer"
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-sm font-bold text-gray-900 mb-4">Get in Touch</p>
                <div className="flex flex-col gap-2">
                  {[
                    { label: "Contact Us", href: "/contact" },
                    { label: "About Company", href: "/about" },
                  ].map(({ label, href }) => (
                    <a
                      key={label}
                      href={href}
                      className="text-sm text-gray-500 hover:text-gray-800 transition-colors cursor-pointer"
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-5 text-center">
            <p className="text-xs text-gray-400">
              &copy; {new Date().getFullYear()} flightfare.pk. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
